import { DefaultTemplate } from '@trashlab/sitesapp/src/organizations/junk-rescue/template/index';
import type { OrgRouteConfig } from '@trashlab/sitesapp/src/organizations/types';

// Route components
import { Route as HomeRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/home/index';
import { Route as AboutRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/about/index';
import { Route as ContactUsRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/contact-us/index';
import { Route as DumpsterFaqRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/dumpster-faq/index';
import { Route as DumpsterRentalsRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/dumpster-rentals/index';
import { Route as DumpsterRentalDetailRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/dumpster-rentals/$dumpsterId/index';
import { Route as CartRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/cart/$cartId/index';
import { Route as CartThankYouRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/cart/$cartId/thankyou';
import { Route as PrivacyPolicyRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/privacy-policy/index';
import { Route as ServiceAreasRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/service-areas/index';
import { Route as TermsRoute } from '@trashlab/sitesapp/src/organizations/junk-rescue/routes/terms-and-conditions/index';

export const TemplateWrapper = DefaultTemplate;

export const routes: Record<string, OrgRouteConfig> = {
  '/': { component: HomeRoute.options.component },
  '/about': { component: AboutRoute.options.component },
  '/contact-us': { component: ContactUsRoute.options.component },
  '/dumpster-faq': { component: DumpsterFaqRoute.options.component },
  '/dumpster-rentals': {
    component: DumpsterRentalsRoute.options.component,
    validateSearch: DumpsterRentalsRoute.options.validateSearch,
    loader: DumpsterRentalsRoute.options.loader,
  },
  '/dumpster-rentals/$dumpsterId': {
    component: DumpsterRentalDetailRoute.options.component,
    params: { parse: DumpsterRentalDetailRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
  '/cart/$cartId': {
    component: CartRoute.options.component,
    params: { parse: CartRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
  '/cart/$cartId/thankyou': {
    component: CartThankYouRoute.options.component,
    params: { parse: CartThankYouRoute.options.params?.parse as NonNullable<OrgRouteConfig['params']>['parse'] },
  },
  '/privacy-policy': { component: PrivacyPolicyRoute.options.component },
  '/service-areas': { component: ServiceAreasRoute.options.component },
  '/terms-and-conditions': { component: TermsRoute.options.component },
};
